/**
 * DeathNotification — HUD element (extracted from PixiHUDRenderer.js in Phase 3D).
 *
 * create(hud) builds the PIXI objects into hud.elements.deathNotification,
 * position(hud) lays them out for hud.screenWidth/Height, update(hud, …) redraws
 * from game state. `hud` is the PixiHUDRenderer coordinator: it owns
 * hudContainer, elements, screen size, _createText() and send().
 */
import * as PIXI from 'pixi.js';

export function create(hud) {
  const container = new PIXI.Container();
  container.visible = false;
  hud.hudContainer.addChild(container);

  const background = new PIXI.Graphics();
  container.addChild(background);

  const baseText = new PIXI.Text({
    text: '',
    style: {
      fontFamily: 'Arial',
      fontSize: 32,
      fontWeight: 'bold',
      fill: 0xffffff
    }
  });
  baseText.anchor.set(0, 0.5);
  container.addChild(baseText);

  const nameText = new PIXI.Text({
    text: '',
    style: {
      fontFamily: 'Arial',
      fontSize: 32,
      fontWeight: 'bold',
      fill: 0xff5050
    }
  });
  nameText.anchor.set(0, 0.5);
  container.addChild(nameText);

  hud.elements.deathNotification = { container, background, baseText, nameText };
}

export function update(hud, notification, callbacks) {
  const dn = hud.elements.deathNotification;
  if (!dn) return;

  if (!notification) {
    dn.container.visible = false;
    return;
  }

  const { uiConfig } = callbacks;
  const now = performance.now();
  const fadeOutDuration = uiConfig?.deathNotification?.fadeOutDuration || 400;
  const timeUntilExpire = notification.expiresAt - now;

  let opacity = 1.0;
  if (timeUntilExpire < fadeOutDuration) {
    opacity = Math.max(0, timeUntilExpire / fadeOutDuration);
  }

  dn.container.visible = true;
  dn.container.alpha = opacity;

  const centerX = hud.screenWidth / 2;
  const centerY = hud.screenHeight / 2 - 40;

  const baseMessage = 'You were eliminated by ';
  dn.baseText.text = baseMessage;
  dn.nameText.text = notification.killerName || 'Unknown';

  const totalWidth = dn.baseText.width + dn.nameText.width;
  const startX = centerX - totalWidth / 2;
  dn.baseText.x = startX;
  dn.baseText.y = centerY;
  dn.nameText.x = startX + dn.baseText.width;
  dn.nameText.y = centerY;

  const padding = 30;
  const blockWidth = totalWidth + padding * 2;
  const blockHeight = 60;

  dn.background.clear();
  dn.background.rect(centerX - blockWidth / 2, centerY - blockHeight / 2, blockWidth, blockHeight);
  dn.background.fill({ color: 0x000000, alpha: 0.5 });
}
